import AlterarSenha from './AlterarSenha.vue';

export default {
  path: 'alterar-senha',
  component: AlterarSenha,
  name: 'alterar-senha',
  meta: { auth: true },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/alterar-senha/rotas.js